<template>
    <vProjectHeader
        logoColor="pricing"
        :categories="categories"
        :actions="dotsMenuActions"
        :project="pricing"
        :shareLinks="shareLinks"
        :hasChanges="hasChanges"
        :hasSnapshot="hasSnapshot"
        :hidePublish="isCreatorShown"
        :hideShare="isCreatorShown"
        @publish="$emit('publish')"
    />
</template>

<script>
import { markRaw } from "vue";
import {
    TagIcon,
    PaintbrushIcon,
    LayoutWindowIcon,
    HeaderIcon,
    ShippingBoxIcon,
    ArrowLeftIcon,
} from "@easy/ui/icons";
import { PRICING_ROUTE_NAMES } from "@/apps/pricing/pricing.routes";
import { mapActions, mapState } from "vuex";
import vProjectHeader from "@/shared/views/vProjectHeader.vue";
import { usePricingCreatorStore } from "@/apps/pricing/project/onboarding/pricing-creator.store";
import { storeToRefs } from "pinia";
import { PAGE_ROUTE_NAMES } from "@/apps/page/page.routes";

export default {
    name: "PricingProjectHeader",
    components: {
        vProjectHeader,
    },
    emits: ["publish"],
    props: {
        actions: {
            type: Array,
            default: () => [],
        },
        shareLinks: {
            type: Array,
            default: () => [],
        },
    },
    setup() {
        const pricingCreatorStore = usePricingCreatorStore();
        const { isCreatorShown, onboardState } = storeToRefs(pricingCreatorStore);
        return { isCreatorShown, onboardState };
    },
    computed: {
        ...mapState(["globalUrl"]),
        ...mapState("pricing", ["pricing", "hasChanges", "hasSnapshot"]),
        dotsMenuActions() {
            return this.isCreatorShown ? [] : this.actions;
        },
        categories() {
            const { page: projectUuid } = this.$route.query;
            const backToPageEdit =
                this.$route.query.page && !this.onboardState.isLoading
                    ? {
                          name: "page",
                          label: this.$t("page.menu.back"),
                          icon: ArrowLeftIcon,
                          handler: () => {
                              this.$router.push({
                                  name: PAGE_ROUTE_NAMES.projectSections,
                                  params: { projectUuid },
                              });
                          },
                      }
                    : {};
            if (this.isCreatorShown) {
                return [
                    backToPageEdit,
                    {
                        label: this.$t("shared.creator.create_new"),
                        name: "page",
                        icon: markRaw(TagIcon),
                    },
                ];
            }
            return [
                backToPageEdit,
                {
                    name: PRICING_ROUTE_NAMES.projectVariants,
                    icon: markRaw(TagIcon),
                    label: this.$t("pricing.menu.variants"),
                    handler: () => this.routeTo(PRICING_ROUTE_NAMES.projectVariants),
                },
                {
                    name: PRICING_ROUTE_NAMES.projectProduct,
                    icon: markRaw(ShippingBoxIcon),
                    label: this.$t("pricing.menu.product"),
                    handler: () => this.routeTo(PRICING_ROUTE_NAMES.projectProduct),
                },
                {
                    label: this.$t("pricing.menu.layout"),
                    icon: markRaw(LayoutWindowIcon),
                    name: PRICING_ROUTE_NAMES.projectLayout,
                    handler: () => this.routeTo(PRICING_ROUTE_NAMES.projectLayout),
                },
                {
                    label: this.$t("pricing.menu.header"),
                    icon: markRaw(HeaderIcon),
                    name: PRICING_ROUTE_NAMES.projectHeader,
                    handler: () => this.routeTo(PRICING_ROUTE_NAMES.projectHeader),
                },
                {
                    label: this.$t("pricing.menu.styles"),
                    name: PRICING_ROUTE_NAMES.projectStyles,
                    icon: markRaw(PaintbrushIcon),
                    handler: () => this.routeTo(PRICING_ROUTE_NAMES.projectStyles),
                },
            ];
        },
    },
    methods: {
        ...mapActions("pricing", ["showSchema"]),
        routeTo(name, forcedView) {
            const { query } = this.$route;
            this.$router.push({ name, query: forcedView ? { ...query, view: forcedView } : query });
        },
    },
};
</script>
